import SlimCTA from "components/SlimCTA";
import React from "react";
import {
  BUTTON_CLASS_CONTEXT,
  BUTTON_TAGS,
  UI_THEME
} from "utils/constants/ui";
import PATHS from "utils/paths";

const DEFAULT_CLASSES = {
  actionsWrapper: "pt3",
  container:
    "w-100 flex flex-column justify-between ba br2 hairline-1 pa3 items-start bg-white"
};

const UnauthedAccountPrompt = ({ header, subheader, customClasses }) => {
  const ctxClasses = { ...DEFAULT_CLASSES, ...customClasses };
  return (
    <SlimCTA
      header={header}
      subheader={subheader}
      customClasses={ctxClasses}
      actions={[
        {
          copy: "Login",
          tag: BUTTON_TAGS.LINK,
          theme: UI_THEME.SLIM,
          href: PATHS.LOGIN,
          classes: {
            contextClass: BUTTON_CLASS_CONTEXT.SECONDARY
          }
        },
        {
          copy: "Sign up",
          tag: BUTTON_TAGS.LINK,
          theme: UI_THEME.SLIM,
          href: PATHS.SIGNUP
        }
      ]}
    />
  );
};

export default UnauthedAccountPrompt;
